/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownRightIcon16Regular = forwardRef('ArrowADownRightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.5 10.44 4.03 2.97a.75.75 0 0 0-1.06 1.06l7.47 7.47H5.25a.75.75 0 0 0 0 1.5h6A1.75 1.75 0 0 0 13 11.25v-6a.75.75 0 0 0-1.5 0v5.19Z" })));
});
